import { Injectable } from '@angular/core';
import { AngularFireStorage, AngularFireUploadTask, AngularFireStorageModule } from '@angular/fire/storage';
import { finalize } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class UploadService {
  constructor(private afStorage: AngularFireStorage) {}

  /** f: event.target.files[0] */
  uploadFile(f): Promise<string> {
    return new Promise((resolve, reject) => {
      const randomId = Math.random().toString(36).substring(2);
      const ext = f.name.substring(f.name.lastIndexOf('.') + 1);
      const ref = this.afStorage.ref(`${randomId}.${ext}`);
      const task = this.afStorage.upload(`${randomId}.${ext}`, f);
      task
        .snapshotChanges()
        .pipe(
          finalize(() => {
            const img = ref.getDownloadURL();
            img.subscribe((url) => {
              resolve(url);
            });
          })
        )
        .subscribe();
    });
  }
}
